import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import CollapsableSidebar from './CollapsableSidebar';
import CollapsableSidebarContainer from './CollapsableSidebarContainer';
import CollapsableSidebarEdgeHoverBuffer from './CollapsableSidebarEdgeHoverBuffer';
import CollapsableSidebarHeaderDeadZone from './CollapsableSidebarHeaderDeadZone';
import withHoveringAndCollapsing from './withHoveringAndCollapsing';
import { useCallback, useRef } from 'react';
import CollapsableSidebarContentWrapper from './CollapsableSidebarContentWrapper';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CollapsableSidebarRoot = ({
  collapsedWidth,
  deadZoneEnter,
  deadZoneLeave,
  errorLoggingTitle,
  fullWidth,
  isHovered,
  isLocked,
  mouseEnter,
  mouseLeave,
  shouldHover,
  showDeadZone,
  toggleLocked,
  toggleHover,
  collapseButtonPosition,
  showTooltip = false,
  fullWidthWhenLocked = true,
  children
}) => {
  const toggleSidebar = useCallback(() => {
    toggleLocked();
    toggleHover();
  }, [toggleLocked, toggleHover]);
  const getWidth = useCallback(shouldDisplayFullWidth => shouldDisplayFullWidth ? fullWidth : collapsedWidth, [collapsedWidth, fullWidth]);
  const shouldRenderDeadZone = !isLocked && showDeadZone;
  const shouldRenderBuffer = !isLocked && isHovered;
  const collapseButtonRef = useRef(null);
  return /*#__PURE__*/_jsxs(CollapsableSidebarContainer, {
    shrink: 0,
    width: getWidth(isLocked && fullWidthWhenLocked),
    onMouseEnter: mouseEnter,
    onMouseLeave: mouseLeave,
    "data-test-id": "view-sidebar-collapsed-container",
    children: [shouldRenderDeadZone && /*#__PURE__*/_jsx(UITooltip, {
      title: I18n.text('svh-workspace-ui-lib.navigation-sidebar.collapse-button.collapsed'),
      disabled: !showTooltip,
      target: collapseButtonRef.current,
      children: /*#__PURE__*/_jsx(CollapsableSidebarHeaderDeadZone, {
        onMouseEnter: deadZoneEnter,
        onMouseLeave: deadZoneLeave,
        onClick: toggleSidebar,
        "data-test-id": "view-sidebar-collapsed-dead-zone"
      })
    }), shouldRenderBuffer && /*#__PURE__*/_jsx(CollapsableSidebarEdgeHoverBuffer, {
      fullWidth: fullWidth
    }), /*#__PURE__*/_jsx(CollapsableSidebar, {
      width: getWidth(isLocked || shouldHover),
      fullWidth: fullWidth,
      collapsedWidth: collapsedWidth,
      showShadow: !isLocked && shouldHover,
      direction: "column",
      className: "selenium-collapsable-sidebar height-100",
      "data-test-id": "view-sidebar-collapsable-sidebar",
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        errorLoggingTitle: errorLoggingTitle,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            height: '100%',
            width: fullWidth
          },
          children: /*#__PURE__*/_jsx(CollapsableSidebarContentWrapper, {
            collapsed: !isLocked && !shouldHover,
            isLocked: isLocked,
            toggleSidebar: toggleSidebar,
            collapseButtonPosition: collapseButtonPosition,
            showTooltip: showTooltip,
            collapseButtonRef: collapseButtonRef,
            children: children
          })
        })
      })
    })]
  });
};
CollapsableSidebarRoot.displayName = 'CollapsableSidebarRoot';
export default withHoveringAndCollapsing(CollapsableSidebarRoot);